import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';

const ProgressBar = ({ status, message, percentage }) => {
  let icon = '';
  let type = '';
  if (status === 'complete') {
    icon = 'step-complete';
    type = 'success';
  } else {
    icon = 'step-pending';
    type = 'primary';
  }
  return (
    <div className={`progress-bar progress-bar-${type}`} style={{ width: `${percentage}%` }}>
      <strong>
        {message}&nbsp;<i className={`wb ${drapcodeIcon(icon)}`}></i>
      </strong>
    </div>
  );
};

export default ProgressBar;
